// @flow
import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import Logo from '../../components/Logo/Logo';
import { P } from '../../components/Typography';
// import facebookIcon from '../../assets/icons/Facebook.svg';
// import twitterIcon from '../../assets/icons/Twitter.svg';
// import vkIcon from '../../assets/icons/Vkontakte (VK).svg';
// import telegramIcon from '../../assets/icons/Telegram.svg';
import { menuLinks } from '../../db/links';
import { LinkButton } from '../../components';
import routes from '../../constants/routes';
import LanguageSelect from '../../components/LanguageSelect';
import useWindowDimensions from '../../utils/windowDemensions';

const FooterABC = () => {
  const { i18n, t } = useTranslation();
  const { width } = useWindowDimensions();
  const toLink = (link: any) => {
    if (i18n.language.indexOf('ru') >= 0 && link?.linkRu) return link?.linkRu;
    if (i18n.language.indexOf('en') >= 0 && link?.linkTo) return link?.linkTo;
    return link?.linkTo;
  };

  return (
    <div className={classnames(styles.container)}>
      <div
        className={classnames(styles.footer)}
      >
        <div
          className={classnames(styles.linkBlock)}
        >
          <Logo />
          {menuLinks.map((link) => (
            <LinkButton
              key={link.name}
              name={t(link.name)}
              to={toLink(link)}
              external={link.external}
              // icon={link.icon ? link.icon : ''}
            >
              {link.icon && (
                <section style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={link.icon} alt={`${link.icon}`} />
                  <p style={{ margin: '0 10px' }}>{t(link.name)}</p>
                </section>
              )}
            </LinkButton>
          ))}
          { width < 1120
            && <LanguageSelect />}
        </div>
        {/* <div className={styles.iconBlock}> */}
        {/*  <img src={facebookIcon} alt="facebookIcon" /> */}
        {/*  <img src={telegramIcon} alt="telegramIcon" /> */}
        {/*  <img src={vkIcon} alt="vkIcon" /> */}
        {/*  <img src={twitterIcon} alt="twitterIcon" /> */}
        {/* </div> */}
      </div>
      <P className={styles.footerText}>support@omahapro.com</P>
      <div className={styles.termsAndConditions}>
        <Link to={routes.app.termAndConditions.root} href="/" className={styles.footerLink}><P transparency="weaker" className={styles.footerText}>Terms and conditions</P></Link>
        <Link to={routes.app.privacy.root} href="/" className={styles.footerLink}><P transparency="weaker" className={styles.footerText}>Privacy</P></Link>
        <Link to="/" href="/" className={styles.footerLink}>
          <P transparency="weaker" className={styles.footerText}>
            Omahapro, All rights reserved
            {' '}
            {new Date().getFullYear()}
          </P>
        </Link>
      </div>
      <div className={`${styles.footerText} ${styles.disclaimer}`}>
        OmahaPro is not a game organizer. The site is for informational and learning purposes only.
      </div>
      {/* eslint-disable-next-line react/no-unescaped-entities,max-len */}
      {/* <P transparency="weaker">Omahapro.com исключительно информационный ресурс. Сайт не предоставляет никаких игровых платформ, не является организатором или рекламой азартных игр. Сайт регулируется исходя от Федерального закона от 29.12.2006 N 244-ФЗ (ред. от 01.05.2016) "О государственном регулировании деятельности по организации и проведению азартных игр и о внесении изменений в некоторые законодательные акты Российской Федерации". Информация на сайте предназначена только для лиц 18+ Политика защиты персональной информации пользователей.</P> */}
    </div>
  );
};

export default FooterABC;
